// Grouped FAQ list. Order is editorial — most-asked first within each
// section. Wording matches the existing site verbatim where possible
// so returning visitors recognise it.

export const faqs = [
  {
    group: "Camping & Parking",
    items: [
      {
        q: "What time does the campground open?",
        a: "Thursday, July 30 opens 11:00 AM–6:00 PM for early-entry pass holders. Friday gates open at 9 AM and stay open throughout the festival.",
      },
      {
        q: "Can I purchase festival tickets without camping?",
        a: "Yes. 3-Day Festival Passes do not include camping — purchase a camping pass separately.",
      },
      {
        q: "Can I get my vehicle in and out of the campground during the festival?",
        a: "There is no guarantee that you'll be able to move your vehicle once you set up camp. If you need to come and go, park in the day lot instead.",
      },
      {
        q: "Can I camp with a single-day ticket?",
        a: "Yes, if you purchase a single-day camping add-on.",
      },
      {
        q: "Can we reserve a spot to camp with a group?",
        a: "Yes — we now have a Group Camping add-on with 50'×50' spaces for 8–10 people and three parking passes.",
      },
      {
        q: "What types of camping are available?",
        a: "Walk-in tent camping, car tent camping, and RV sites. All sites are primitive — no hookups.",
      },
      {
        q: "Is parking included?",
        a: "Yes, for all vehicles under 20′ in length and not pulling a trailer. RVs and trailers require an RV pass.",
      },
      {
        q: "Are there RV hookups?",
        a: "No — all sites are primitive.",
      },
      {
        q: "Can we use generators in the campground or RV area?",
        a: "No. Solar generators are welcome.",
      },
      {
        q: "Is there a family camping area?",
        a: "Yes, included at no extra charge, with quiet hours from end of music to 7 AM.",
      },
    ],
  },
  {
    group: "Tickets",
    items: [
      {
        q: "Can I transfer or sell my tickets if I can't make it?",
        a: "Yes — tickets are transferable through the Humanitix platform. We recommend reselling via your social channels or CashOrTrade.org.",
      },
      {
        q: "Will tickets be available at the gate?",
        a: "We'll have tickets available to purchase at the gate, while they last.",
      },
    ],
  },
  {
    group: "On-Site",
    items: [
      {
        q: "Are dogs allowed at Rhythms on the Rio?",
        a: "Yes. Well-behaved dogs are allowed in the camping area, on leash at all times. Dogs are not permitted in the festival (stage) area.",
      },
      {
        q: "Will ice be available?",
        a: "Yes — 7 lb bags of ice for sale on site.",
      },
      {
        q: "Will water be available?",
        a: "Yes — a freshwater tanker truck on site.",
      },
      {
        q: "Are fires allowed?",
        a: "Only propane fire rings. Propane grills are also permitted — no wood or charcoal.",
      },
      {
        q: "Should we bring bikes?",
        a: "Yes! Del Norte has great mountain biking and cycling trails — bring them.",
      },
      {
        q: "Is there river access from the campground?",
        a: "The river is directly across the street at the new Del Norte River Park.",
      },
    ],
  },
];
